import React from "react";

export const Display = (props) => {
  
  return <div className="display">{`${props.display}`}</div>;
};
